export default __webpack_public_path__ + "static/media/IconRemove.a019e8c2.svg";